import * as Constants from '../Constant';

const initialState = {
    message: {},
    patientList: {},
    patientNameList: [],
    suggestedPatientId: null
}

export default function patientReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.POST_PATIENT:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_PATIENT:
            return {
                ...state,
                patientList: action.payload,
            }
        case Constants.UPDATE_PATIENT:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.DELETE_PATIENT:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_PATIENT_NAME:
            return {
                ...state,
                patientNameList: action.payload,
            }
        case Constants.GET_SUGGESTED_PATIENT_IDS:
            return {
                ...state,
                suggestedPatientId: action.payload,
            }
        default:
            return state;
    }
}